import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import { usePrinciples } from "./hooks/usePrinciples";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PrinciplesForm from "./components/principlesForm";

function Principles() {
  const {
    isLargeScreen,
    principles,
    isSystemAdmin,
    isOrgAdmin,
    open,
    editMode,
    currentPrinciple,
    // handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  } = usePrinciples();

  const { palette } = useTheme();
  const primaryDark = palette.primary.dark;

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="Welcome to ALT Coach Principles"
            subtitle="Set the principles for your school"
          />
        </FlexBetween>

        <Box mt={2}>
          {principles.map((principle) => (
            <Box key={principle._id}>
              <FlexBetween>
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    gutterBottom
                    color="textPrimary"
                  >
                    Principle {principle.principleNumber}:
                  </Typography>
                  <Typography variant="h6" gutterBottom color={primaryDark}>
                    {principle.name}
                  </Typography>
                </Box>
                {(isSystemAdmin || isOrgAdmin) && (
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      borderRadius: "5px",
                      fontSize: "12px",
                      padding: "5px 10px",
                    }}
                    onClick={() => handleEditOpen(principle)}
                  >
                    <EditOutlinedIcon sx={{ mr: "0.5rem" }} />
                    Edit Principle
                  </Button>
                )}
              </FlexBetween>
              <p>{principle.description}</p>
            </Box>
          ))}
        </Box>
      </WidgetWrapper>
      {/* The Dialog component is a modal dialog that is displayed over the current page. */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {editMode
            ? `Edit Principle - ${currentPrinciple.name}`
            : "Add a New Principle"}
        </DialogTitle>
        <DialogContent>
          <PrinciplesForm
            editMode={editMode}
            currentPrinciple={currentPrinciple}
            setOpen={setOpen}
            handleClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Principles;
